import type { AgentWithDeployments } from "@/schemas/agent.schema";
import { computed } from "vue";
import { useAgentsQuery } from "@/queries/agents.query";

/**
 * Composable that provides agents with their deployments.
 *
 * Deployments are now included inline in the GET /agents response,
 * so this composable simply maps the agent data to the expected type.
 */
export function useAgentsWithDeployments() {
  const agentsQuery = useAgentsQuery();

  const data = computed<AgentWithDeployments[]>(() => {
    const agents = agentsQuery.data.value ?? [];

    return agents.map((agent) => ({
      ...agent,
      deployments: agent.deployments ?? {
        sip: undefined,
        whatsapp: undefined,
        whatsappBaileys: undefined,
        chatWidget: undefined,
        telegram: undefined,
      },
    }));
  });

  const isLoading = computed(() => agentsQuery.isLoading.value);
  const isError = computed(() => !!agentsQuery.error.value);
  const isSuccess = computed(() => !agentsQuery.error.value && !!agentsQuery.data.value);
  const error = computed(() => agentsQuery.error.value);

  return {
    data,
    isLoading,
    isError,
    isSuccess,
    error,
    agentsQuery,
  };
}
